import { FC, memo, useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import { HistoryTable } from 'bank-entity-history'
import { HistoryEntity } from 'commons/types/DTO/bank/historyAudit'
import { TableDataQa } from 'commons/types/enums'
import { Request } from 'commons/utils/request'
import { CircularProgress } from 'ui/components'
import { Dialog, DialogFace } from 'ui/components/Dialog'

export const HistoryDialog: FC<{ id: number; onClose: () => void }> = memo(({ id, onClose }) => {
  const [pagination, setPagination] = useState({ page: 1, size: 10 })

  const { data, isFetching } = useQuery<{
    items: HistoryEntity[]
    totalCount: number
    form: { page: number; size: number }
  }>({
    queryKey: ['crb-history', id, pagination],
    queryFn: () =>
      Request.post(Request.urls.bank.crbMonitorHistory, {
        connectionId: id,
        ...pagination
      })
  })

  return (
    <Dialog id="crb-monitor-history" onClose={onClose} face={DialogFace.PRIMARY} title="CRB History">
      {!data && <CircularProgress centered />}
      {data && (
        <HistoryTable
          dataQa={TableDataQa.CRB_MONITOR_HISTORY}
          items={data.items}
          loading={isFetching}
          pagination={{
            page: data.form.page,
            size: data.form.size,
            total: data.totalCount,
            onChange: (page, size) => setPagination({ page, size })
          }}
        />
      )}
    </Dialog>
  )
})
